module.exports = __webpack_public_path__ + "img/pm_9.be84f04a.png";